import React from 'react';

const Age = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_4217_71)">
            <g clipPath="url(#clip1_4217_71)">
                <path
                    d="M15.8892 10.853C15.6102 11.2172 15.1808 11.4346 14.7222 11.444C14.2645 11.432 13.8364 11.2151 13.5562 10.853"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.4438 10.853C10.1651 11.2169 9.73609 11.4343 9.27784 11.444C8.81988 11.4321 8.39149 11.2151 8.11084 10.853"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.9999 20.333C15.7528 20.3311 19.0411 17.82 20.0309 14.2C21.2443 14.0678 22.1208 12.977 21.9886 11.7636C21.8762 10.7325 21.062 9.91829 20.0309 9.80596C18.8219 5.37056 14.2462 2.75504 9.81081 3.96403C6.96635 4.73937 4.74421 6.9615 3.96888 9.80596C2.75551 9.93816 1.87904 11.029 2.01124 12.2423C2.12357 13.2734 2.93781 14.0876 3.96889 14.2C4.9587 17.82 8.24702 20.3311 11.9999 20.333Z"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.2218 15.007C12.9487 16.1176 11.051 16.1176 9.77783 15.007"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.8892 7.19099C11.2119 7.42643 11.6007 7.55415 12.0002 7.55599C13.0741 7.53164 13.9249 6.64131 13.9006 5.56739C13.877 4.52775 13.0398 3.69057 12.0002 3.66699"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_4217_71">
                <rect width="24" height="24" fill="white" />
            </clipPath>
            <clipPath id="clip1_4217_71">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default Age;
